<template>
  <div>
    <meta itemprop="name" :content="tour.name" />
    <meta itemprop="image" :content="meta.page_property_image" />
    <meta itemprop="brand" :content="meta.brand || 'YouTravelMe'" />
    <meta itemprop="sku" :content="tour.id" />
    <meta itemprop="mpn" :content="tour.id" />
    <div  itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
      <meta itemprop="lowPrice" :content="minPrice">
      <meta itemprop="highPrice" :content="maxPrice">
      <meta itemprop="priceCurrency" :content="tour.currency.toUpperCase()">
      <meta itemprop="offerCount" :content="datesAvailable.length">


      <template v-if="!dates.length">
        <div
          class="u-hidden"
          itemprop="offers"
          itemscope=""
          itemtype="https://schema.org/Offer"
        >
          <meta itemprop="availability" content="https://schema.org/OutOfStock" />
          <meta itemprop="price" content="0" />
        </div>
      </template>

      <template v-for="date in datesAvailable">
        <div
          :key="`${date.id}-offer`"
          class="u-hidden"
          itemprop="offers"
          itemscope=""
          itemtype="https://schema.org/Offer"
        >
          <meta
            itemprop="availability"
            :content="`https://schema.org/${
              meta.is_in_stock ? 'InStock' : 'SoldOut'
            }`"
          />
          <meta itemprop="price" :content="getDatePrice(date)" />
          <meta itemprop="priceCurrency" :content="getDateCurrency(date)" />
          <meta itemprop="validFrom" :content="getISODate()" />
          <meta itemprop="url" :content="meta.alternate_link" />
          <meta
            itemprop="priceValidUntil"
            :content="getFormattedDate(date.display_date_to)"
          />
          <meta
            v-for="type in getTypes(tour)"
            :key="type"
            itemprop="category"
            :content="type"
          />
        </div>

        <div
          :key="`${date.id}-event`"
          class="u-hidden"
          itemscope=""
          itemtype="https://schema.org/Event"
        >
          <meta
            itemprop="startDate"
            :content="getFormattedDate(date.display_date_from)"
          />
          <meta
            itemprop="endDate"
            :content="getFormattedDate(date.display_date_to)"
          />
          <meta itemprop="name" :content="tour.name" />
          <meta itemprop="description" :content="meta.description" />
          <meta
            itemprop="eventAttendanceMode"
            content="https://schema.org/OfflineEventAttendanceMode"
          />
          <meta
            itemprop="eventStatus"
            content="https://schema.org/EventScheduled"
          />
          <meta itemprop="image" :content="meta.page_property_image" />
          <meta itemprop="url" :content="meta.alternate_link" />
          <div
            class="u-hidden"
            itemprop="location"
            itemscope=""
            itemtype="https://schema.org/Place"
          >
            <meta itemprop="name" :content="tour.country" />
            <div
              class="hidden"
              itemprop="address"
              itemscope=""
              itemtype="http://schema.org/PostalAddress"
            >
              <meta itemprop="addressCountry" :content="tour.country" />
              <meta itemprop="addressRegion" :content="tour.region" />
            </div>
          </div>
          <div
            class="u-hidden"
            itemprop="offers"
            itemscope=""
            itemtype="https://schema.org/Offer"
          >
            <meta
              itemprop="availability"
              :content="`https://schema.org/${
                meta.is_in_stock ? 'InStock' : 'SoldOut'
              }`"
            />
            <meta itemprop="price" :content="getDatePrice(date)" />
            <meta itemprop="priceCurrency" :content="getDateCurrency(date)" />
            <meta
              v-if="tour.date_publish"
              itemprop="validFrom"
              :content="getISODate(new Date(tour.date_publish * 1000))"
            />
            <meta itemprop="url" :content="meta.alternate_link" />
          </div>
          <div
            class="u-hidden"
            itemprop="organizer"
            itemscope=""
            itemtype="https://schema.org/Organization"
          >
            <meta itemprop="name" :content="tour.expert_data.first_name" />
            <meta itemprop="url" :content="tour.expert_data.link" />
          </div>
          <div
            class="u-hidden"
            itemprop="performer"
            itemscope=""
            itemtype="https://schema.org/Organization"
          >
            <meta itemprop="name" :content="tour.expert_data.first_name" />
            <meta itemprop="url" :content="tour.expert_data.link" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { formatISO, parse } from "date-fns";

export default {
  props: {
    tour: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
  },
  computed: {
    minPrice() {
      return Math.min(...this.datesAvailable.map(offer => offer.price)) || 0;
    },
    maxPrice() {
      return Math.max(...this.datesAvailable.map(offer => offer.price)) || 0;
    },
    dates() {
      return this.tour.trip_dates || [];
    },
    datesAvailable() {
      return this.dates.filter(
        ({ date_from, date_to, disabled }) => date_from && date_to && !disabled
      );
    },
  },
  methods: {
    getDatePrice({ display_price = 0 }) {
      return +display_price.toFixed(2);
    },
    getDateCurrency({ currency }) {
      return currency.toUpperCase();
    },
    getTypes({ type }) {
      return type?.split(", ") || [];
    },
    getISODate(date = new Date()) {
      if(typeof date == "undefined"){
        return "";
      }
      return formatISO(date, { representation: "date" });
    },
    getFormattedDate(date) {
      return this.getISODate(parse(date, "dd.MM.yyyy", new Date()));
    },
  },
};
</script>
